





































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import RecipientLookupMobile from '@/components/MobileComponents/ForwardLetterMobile/RecipientLookupMobile/RecipientLookupMobile.vue';
import FastSendRecipientSelectorMobile from '@/components/MobileComponents/FastSendMobile/FastSendRecipientSelectorMobile/FastSendRecipientSelectorMobile.vue';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import * as letterOwnerService from '@/store/Services/letterOwnerService';
import store from '@/store';
import { LetterOwnerForSendingFaxAndEmailAndSms } from '../../../store/models/LetterOwner/LetterOwnerForSendingFaxAndEmailAndSms';
import MessageBox from '@/components/UiComponents/MessageBox.vue';
import FileSelector from '@/components/UiComponents/FileSelector.vue';
import InPlaceMessageBox from '@/components/UiComponents/InPlaceMessageBox.vue';
import File from '../../../store/models/Letter/File';
import LetterAttachmentMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterAttachmentMobile/LetterAttachmentMobile.vue';
import Parts from '../../../store/models/Letter/Parts';
import { LetterOwner } from '../../../store/models/LetterOwner/LetterOwner';
import * as letterService from '@/store/Services/letterServices';
import { isMoment } from 'moment';
import * as util from '@/util/utils';
import FullPageLoader from '@/components/UiComponents/FullPageLoader.vue';
import PrioritySelectorMobile from './PrioritySelectorMobile/PrioritySelectorMobile.vue';
import { LetterOwnerEmail } from '@/store/models/LetterOwner/LetterOwnerEmail';
import { Letter } from '../../../store/models/Letter/Letter';
import DependentItemMobile from './DependentItemMobile/DependentItemMobile.vue';
import {DependentLetter} from '@/store/models/Letter/DependentLetter';
import LetterReferencesToOtherLetters from '../../../store/models/Letter/LetterReferencesToOtherLetters';
import * as $ from 'jquery';
import SendButtonWithOptions from '@/components/Cartable/FastSend/SendButtonWithOptions.vue';
import InPlaceSendingOptionsMobile from '@/components/MobileComponents/FastSendMobile/InPlaceSendingOptionsMobile.vue';
import CustomAccardion from '@/components/UiComponents/CustomAccardion.vue';

@Component({
    components:{RecipientLookupMobile, FastSendRecipientSelectorMobile, MessageBox, FileSelector, LetterAttachmentMobile, FullPageLoader, InPlaceMessageBox,PrioritySelectorMobile , DependentItemMobile, InPlaceSendingOptionsMobile,CustomAccardion}
})
export default class FastSentMobile extends Vue{
    recipients: LetterOwnerWithFaxAndEmails[] = [];
    selectedMainRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    selectedDraftRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    selectedCopyRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    @Prop() dependentLetters?: DependentLetter[];
    @Watch('dependentLetters')
    onDependentLettersChanged(){
        this.addDependentLettersAttachments();
    }
    addDependentLettersAttachments(){
        if(!this.dependentLetters)return;
        this.dependentLetters.forEach(dependent => {
            if(dependent.dependencyType === 'attaching'){
                
                if(dependent.parts){
                    dependent.parts.forEach(part => {
                        this.attachments.push(part.file);
                    });
                }
            }
        });
    }
    shallShowMessageBox = false;
    // @Watch('shallShowMessageBox')
    // onShallShowMessageBoxChanged(n: boolean, o: boolean)
    // {
    //     if(!n && o){
    //          $("#sendingOptions-dropdown").dropdown({action:'nothing'});
    //          alert("test");
    //     }
    // }

    msgBoxBtns = 'ok';
    messageType = 'success';
    message="";
    title = '';
    content = '';
    loadingFile = false;
    loadedPercent = 0;
    currentAttachedFileName = '';
    isLetterSent = false;
    attachments = [] as File[];
    loading = false;
    priority = 1;
    shallSign = true;
    shallSetCopyReceivers = true;
    @Prop() mode?: string;
    
    @Watch('mode') 
    onModeChanged(n: string, o: string){
        this.selectedMainRecipients.length = 0;
        this.selectedCopyRecipients.length = 0;
        this.selectedDraftRecipients.length = 0;
        this.title = '';
        this.content = '';
    }
    async created(){
        const ownerId = store.state.ownerId;
        this.recipients =   await letterOwnerService.getOwnerRecipients(ownerId);
        this.addDependentLettersAttachments();
    }

    mounted(){
        $(' #fastSendAccordion').accordion();
    }

    selectRecipient(recipient: LetterOwnerWithFaxAndEmails, listName: string){
        switch(listName){
            case 'main':
                this.shallShowMainLookup = false;
                $('#fastSendAccordion').accordion('close',0);
                break;
            case 'copy':
                this.shallShowCopyLookup = false;
                $('#fastSendAccordion').accordion('close',1);
                break;
            case 'draft':
                this.shallShowDraftLookup = false;
                $('#fastSendAccordion').accordion('close',2);
                break;
        }
        let addedItem =  this.selectedMainRecipients.find(item=>item.id === recipient.id);
        if(!addedItem) 
            addedItem = this.selectedCopyRecipients.find(item=>item.id === recipient.id);
        if(!addedItem)
            addedItem = this.selectedDraftRecipients.find(item=>item.id === recipient.id);
        if(!addedItem){
            if(listName === 'main'){
                this.selectedMainRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            else if(listName === 'copy'){
                this.selectedCopyRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            else if(listName === 'draft'){
                this.selectedDraftRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
            }
            
        }
            
    }


    onRecipientRemoved(id: string, listName: string){

        let list = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
        if(listName == 'main'){
            list = this.selectedMainRecipients;
        }
        else if(listName == 'draft'){
            list = this.selectedDraftRecipients;
        }
        else if(listName == 'copy'){
            list = this.selectedCopyRecipients;
        }
        const removedItem =  list.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  list.indexOf(removedItem);
        list.splice(index,1);        
    }
    test(){
        console.log(this.selectedDraftRecipients);
    }
    onFileSelectorChanged(file: any){
        const reader = new FileReader();
        reader.addEventListener("progress",(evt)=>{
            this.loadedPercent = (evt.loaded / evt.total) * 100;
        });
        reader.addEventListener("loadend",(x)=>{
            const attachedFile = {} as File;
            if(x.target)
            {
                attachedFile.id = '00000000-0000-0000-0000-000000000000';
                attachedFile.extension = file.name;
                attachedFile.content =  util.base64RemovePrefix((x.target as any).result);
                this.attachments.push(attachedFile);
            }
            this.loadingFile = false;
        });
        
        this.loadingFile = true;
        reader.readAsDataURL(file);
        
    }
    onAttachmentRemoved(index: number){
            this.attachments.splice(index,1);
    }
    removeNotSelectedEmails(list: LetterOwnerForSendingFaxAndEmailAndSms[]){
        list.forEach(recipient=>{
            const emailsToRemove = [] as LetterOwnerEmail[];
            for(let i = 0;i<recipient.emails.length; i++ ){
                if(!recipient.emails[i].canBeUsedForSending)
                    emailsToRemove.push(recipient.emails[i]);
            }
            emailsToRemove.forEach(removingEmail=>{
                const index =  recipient.emails.indexOf(removingEmail);
                recipient.emails.splice(index,1);
            }); 
        });
    }
    async send(shallSaveforSender: boolean){
        
        this.msgBoxBtns = 'ok';
        this.messageType = 'fail';
        if(this.title.trim() === ''){
            this.message = 'عنوان نامه وارد نشده است';
            this.shallShowMessageBox = true;
            return;
        }
        if(this.content === '' ){
            this.message = 'متن نامه وارد نشده است';
            this.shallShowMessageBox = true;
            return;
        }
        if(!shallSaveforSender && this.selectedMainRecipients.length === 0  && this.selectedDraftRecipients.length === 0)
        {
            this.message = 'هیچ گیرنده اصلی یا پیش نویس انتخاب نشده است';
            this.shallShowMessageBox = true;
            return;
        }
        //this.shallShowMessageBox = true;
        this.loading = true;
        const dto = {} as any;
        dto.stringContent = this.content;
        dto.abstract = this.content;
        dto.title = this.title;
        dto.parts = [] as Parts[];
        this.attachments.forEach((attachedItem,index)=>{
            const part = {} as Parts;
            part.partIndex = index;
            part.file = attachedItem;
            dto.parts.push(part);
        });
        const sender = {} as LetterOwner;
        sender.id = store.state.ownerId;
        dto.sender = sender;
        this.removeNotSelectedEmails(this.selectedMainRecipients);
        this.removeNotSelectedEmails(this.selectedCopyRecipients);
        this.removeNotSelectedEmails(this.selectedDraftRecipients);
        dto.recievers = this.selectedMainRecipients;
        dto.copyRecievers = this.selectedCopyRecipients;
        dto.draftRecievers = this.selectedDraftRecipients;
        dto.priority = this.priority;
        dto.shallSign = this.shallSign;
        dto.shallShowCopyReceiversInLetter = this.shallSetCopyReceivers;

        if(this.dependentLetters){
        
            const tempArray = [] as LetterReferencesToOtherLetters[];
            this.dependentLetters.forEach(x=>{
                const dependencyItem = {} as LetterReferencesToOtherLetters;
                dependencyItem.letterId = x.id;
                dependencyItem.letterTitle = x.title;
                dependencyItem.letterNo = x.letterNo;
                if(x.dependencyType === 'bending')//refrence
                    dependencyItem.dependencyType = 2
                else if(x.dependencyType === 'following')//follow
                    dependencyItem.dependencyType = 1
                else if(x.dependencyType === 'returning')//answer
                    dependencyItem.dependencyType = 0
                else if(x.dependencyType === 'attaching')//attach
                    dependencyItem.dependencyType = 3
                tempArray.push(dependencyItem);
                
            });
            dto.letterRefrences = tempArray;
        }
        if(this.mode == 'send' && !shallSaveforSender){
            const info = await letterService.SendLetterFast(dto);
            if(info.letterNumber){
                this.message = `نامه با شماره ${info.letterNumber} ارسال شد.`
                //this.msgBoxBtns = 'ok';
                //this.messageType = 'success';
                //this.shallShowMessageBox = true;
                this.isLetterSent = true;
                this.$emit('fastsend-canceled');
                store.state.eventHub.$emit("show-message",this.message);
                if(this.dependentLetters){
                    if(this.dependentLetters.length >0)
                        store.state.eventHub.$emit('dependent-letter-sent',this.dependentLetters[0].letterPossessionId);
                }
            }
        }
        else{
            const request = {} as any;
            if(shallSaveforSender){
                dto.sener = null;
                request.isForSender = true;
            }
            
            request.dto = dto;
            const info = await letterService.SaveDraft(request);
            if(info && info.isAnyDraftSaved){
                //this.messageType = 'success';
                this.message = 'پیش نویس ارسال شد';
                //this.msgBoxBtns = 'ok';
                //this.shallShowMessageBox = true;
                this.isLetterSent = true;
                this.$emit('fastsend-canceled');
                store.state.eventHub.$emit("show-message",this.message);
            }
        }
        this.loading = false;

    }
    cancel(){
        this.msgBoxBtns = 'yesNo';
        this.message = "آیا مطمئن هستید؟";
        this.messageType = '';
        this.shallShowMessageBox = true;
    }

    onMessageBoxBtnClicked(btn: string){
        if(this.isLetterSent)
            this.$emit('fastsend-canceled');
        if(btn === 'ok' || btn === 'no')
            this.shallShowMessageBox = false;
        else if(btn === "yes"){
            this.shallShowMessageBox = false;
            this.$emit('fastsend-canceled');
        }
    }
    onPriorityChanged(priority: string){
        if(priority === 'low')
            this.priority = 1;
        else if(priority === 'med')
            this.priority = 5;
        else if(priority === 'high')
            this.priority = 10;
    }
    shallShowMainLookup = false;
    shallShowCopyLookup = false;
    shallShowDraftLookup = false;
    onAddRecipientRequest(mode: string){
        switch(mode){
            case 'main':
                this.shallShowMainLookup = true;
                break;
            case 'copy':
                this.shallShowCopyLookup = true;
                break;
            case 'draft':
                this.shallShowDraftLookup = true;
                break;
        }
    }
    
    toggleSendOption(options: any){       
            this.shallSign = options.sign;
            this.shallSetCopyReceivers = options.setCopy;
    }
    shallShowSendingOptions = false;
    onSendingOptionsClosed(){
        this.shallShowSendingOptions = false;
    }
    showSendingOptions(){
        this.shallShowSendingOptions = true;
    }
}


